function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFooterSocialFb = function SvgFooterSocialFb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 20
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M335.821 7259v-9h2.732l.446-4h-3.179v-1.948c0-1.03.026-2.052 1.466-2.052h1.458v-2.86a16.121 16.121 0 0 0-2.519-.14c-2.646 0-4.3 1.657-4.3 4.7v2.3H329v4h2.923v9Z",
    transform: "translate(-329 -7239)",
    style: {
      fill: "#202020",
      fillRule: "evenodd"
    }
  }));
};

export { SvgFooterSocialFb as ReactComponent };
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='10' height='20' viewBox='0 0 10 20'%3e%3cdefs%3e%3cstyle%3e.a%7bfill:%23202020;fill-rule:evenodd;%7d%3c/style%3e%3c/defs%3e%3cpath class='a' d='M335.821,7259v-9h2.732l.446-4h-3.179v-1.948c0-1.03.026-2.052,1.466-2.052h1.458v-2.86a16.121,16.121,0,0,0-2.519-.14c-2.646,0-4.3,1.657-4.3,4.7v2.3H329v4h2.923v9Z' transform='translate(-329 -7239)'/%3e%3c/svg%3e";